import React from 'react'
import { useNavigate } from 'react-router-dom'
import i18next from 'i18next'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  logoTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    fontFamily: "'Inter', sans-serif",
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
    margin: 'auto 20px',
  },
}))

const TopBarLogo = ({ isDarkModeActive }) => {
  const history = useNavigate()
  const lang = i18next.language
  const classes = useStyles()
  return (
    <div
      className={classes.logoTitle}
      style={{ color: isDarkModeActive ? 'white' : 'rgb(0, 119, 181)' }}
      onClick={() => history('/home')}
    >
      {lang === 'ar' ? 'هيوتيوبيا' : 'hutupia'}
    </div>
  )
}

export default TopBarLogo
